import React from 'react';

/**
 * Componente Card reutilizable
 * 
 * @param {Object} props - Propiedades del componente
 * @param {ReactNode} props.children - Contenido de la tarjeta
 * @param {string} props.className - Clases adicionales
 * @param {boolean} props.hover - Si la tarjeta debe mostrar efectos al pasar el ratón
 * @param {boolean} props.flat - Si la tarjeta no debe tener sombra
 * @returns {JSX.Element} - Componente Card
 */
const Card = ({ children, className = '', hover = false, flat = false, ...props }) => {
  return (
    <div 
      className={`card ${hover ? 'hover:bg-gray-700 transition-colors' : ''} ${
        flat ? '' : 'shadow-md'
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

/**
 * Componente para el encabezado de la tarjeta
 */
export const CardHeader = ({ children, className = '' }) => {
  return (
    <div className={`card-header ${className}`}>
      {children}
    </div>
  );
};

/**
 * Componente para el cuerpo de la tarjeta
 */
export const CardBody = ({ children, className = '' }) => {
  return (
    <div className={`card-body ${className}`}>
      {children}
    </div>
  );
};

/**
 * Componente para el pie de la tarjeta
 */
export const CardFooter = ({ children, className = '' }) => {
  return (
    <div className={`card-footer ${className}`}>
      {children}
    </div>
  );
};

export default Card;